<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-25 14:09:31
-->
<template>
  <div class="contain">
    <section class="profile">
      <div class="header">
        <span>公司简介</span>
      </div>
      <div>{{ brief || '-' }}</div>
    </section>
    <section class="essential">
      <div class="header">
        <span>企业基本信息</span>
      </div>
      <div>
        <table>
          <tr>
            <td>所在区域</td>
            <td>{{ entInformation.region || '-' }}</td>
            <td>办公地址</td>
            <td>{{ entInformation.workAddress || '-' }}</td>
            <td>企业类型</td>
            <td>{{ entInformation.entType || '-' }}</td>
          </tr>
          <tr>
            <td>公司电话</td>
            <td>{{ entInformation.entTel || '-' }}</td>
            <td>公司邮箱</td>
            <td>{{ entInformation.entMail || '-' }}</td>
            <td>网址</td>
            <td>{{ entInformation.entWeb || '-' }}</td>
          </tr>
          <tr>
            <td>从业人数</td>
            <td>{{ entInformation.workNumber || '-' }}</td>
            <td>行政人员人数</td>
            <td>{{ entInformation.adminNumber || '-' }}</td>
            <td>研发人员人数</td>
            <td>{{ entInformation.researchNumber || '-' }}</td>
          </tr>
          <tr>
            <td>博士人数</td>
            <td>{{ entInformation.phNumber || '-' }}</td>
            <td>硕士人数</td>
            <td>{{ entInformation.masterNumber || '-' }}</td>
            <td>本科人数</td>
            <td>{{ entInformation.courseNumber || '-' }}</td>
          </tr>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { getEntDetail } from '@api/corporateInteraction/enterprise'
export default {
  props: {
    entName: {
      type: String,
      default: ''
    },
    creditCode: {
      type: String,
      default: ''
    }
  },
  computed: {},
  components: {},
  data() {
    return {
      videos: [],
      pictures: [],
      entInformation: {},
      brief: '',
      srcList: []
    }
  },
  watch: {
    creditCode(val) {
      this.getCompanyPages()
    }
  },
  created() {},
  mounted() {
    this.getCompanyPages()
  },
  methods: {
    getCompanyPages() {
      getEntDetail({ creditCode: this.creditCode }).then(res => {
        if (res.data.code == '0000') {
          this.videos = res.data.data.videos || []
          this.pictures = res.data.data.pictures || []
          this.brief = res.data.data.entData.brief
          const {
            workAddress,
            entType,
            entTel,
            entMail,
            entWeb,
            workNumber,
            adminNumber,
            researchNumber,
            phNumber,
            masterNumber,
            courseNumber
          } = res.data.data.entData
          this.entInformation = {
            workAddress,
            entType,
            entTel,
            entMail,
            entWeb,
            workNumber,
            adminNumber,
            researchNumber,
            phNumber,
            masterNumber,
            courseNumber
          }
          this.entInformation.region =
            res.data.data.entData.province +
            res.data.data.entData.city +
            res.data.data.entData.county
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /** 打开弹性 */
    onShow(item) {
      this.exhibitImg = item
      this.showImg = true
    }
  }
}
</script>
<style lang="scss" scoped>
.contain {
  padding-bottom: 0.2rem;
  section {
    .header {
      color: rgba(255, 255, 255, 100);
      font-size: 0.16rem;
      margin-bottom: 0.16rem;
      > span {
        font-weight: 600;
      }
      &::before {
        content: '';
        margin-top: -0.03rem;
        vertical-align: middle;
        width: 0.03rem;
        height: 0.17rem;
        display: inline-block;
        margin-right: 0.1rem;
        background: #00fffe;
      }
    }
    .video {
      display: flex;
      flex-wrap: wrap;
      & > div {
        width: 300px;
        video {
          width: 100%;
          height: 198px;
        }
        img {
          width: 100% !important;
          height: 198px;
        }
      }
    }
  }
  & > .profile {
    & > div:nth-child(2) {
      line-height: 0.28rem;
      color: rgba(255, 255, 255, 85);
      font-size: 0.16rem;
    }
  }
  & > .essential {
    table {
      width: 100%;
      border-collapse: collapse;
      color: rgba(255, 255, 255, 100);
      font-size: 0.16rem;
      border: 1px solid rgba(46, 178, 236, 1);
      td {
        border: 1px solid rgba(46, 178, 236, 0.5);
        // height: 0.72rem;
        // line-height: 0.72rem;
      }
      tr {
        > td:nth-child(odd) {
          color: rgba(0, 255, 254, 100);
          text-align: center;
          background-color: rgba(0, 103, 166, 0.35);
          padding: 0.18rem 0.2rem;
        }
        > td:nth-child(even) {
          width: 3.4rem;
          padding: 0 0.3rem;
          padding: 0.18rem 0.2rem;
        }
      }
    }
  }
}
</style>
